import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import RevenueNetIncomeBarChart from "../chart/RevenueNetIncomeBarChart";
import RevenueByRegionLineChart from "../chart/RevenueByRegionLineChart";
import RevenueBySegmentLineChart from "../chart/RevenueBySegmentLineChart";
import RevenueBreakdownChart from "../chart/RevenueBreakdownChart";
import ProfitMarginLineChart from "../chart/ProfitMarginLineChart";
import EPSLineChart from "../chart/EPSLineChart";
import ExpenseRatioChart from "../chart/ExpenseRatioChart";
import RnDRatioChart from "../chart/RnDRatioChart";
import EbitEbitdaLineChart from "../chart/EbitEbitdaLineChart";


export default function StockIncomeChart({ ticker }) {
  const [selectedPeriod, setSelectedPeriod] = useState("quarter");

  return (
    <div className="w-100 h-100" style={{ minHeight: "300px" }}>
      <div className="d-flex justify-content-start align-items-center mb-2 ps-3">
        <div className="btn-group btn-group-sm" role="group" aria-label="손익 차트 기간 선택">
          <button
            type="button"
            className={`btn ${selectedPeriod === "quarter" ? "btn-primary" : "btn-outline-secondary"}`}
            onClick={() => setSelectedPeriod("quarter")}
          >
            분기
          </button>
          <button
            type="button"
            className={`btn ${selectedPeriod === "annual" ? "btn-primary" : "btn-outline-secondary"}`}
            onClick={() => setSelectedPeriod("annual")}
          >
            연간
          </button>
        </div>
      </div>
      <Row style={{ margin: "0 auto" }}>
        <Col xs={12} sm={12} md={12} lg={4} xl={4} className="mb-2">
          {/* 순이익/매출 */}
          <RevenueNetIncomeBarChart ticker={ticker} selectedPeriod={selectedPeriod} />
        </Col>
        <Col xs={12} sm={12} md={12} lg={4} xl={4} className="mb-2">
          {/* 지역별 매출현황 */}
          <RevenueByRegionLineChart ticker={ticker} selectedPeriod={selectedPeriod} />
        </Col>
        <Col xs={12} sm={12} md={12} lg={4} className="mb-2">
          {/* 제품부문별 매출현황 */}
          <RevenueBySegmentLineChart ticker={ticker} selectedPeriod={selectedPeriod} />
        </Col>
      </Row>
      <Row style={{ margin: "0 auto" }}>
        <Col xs={12} sm={12} md={12} lg={4} className="mb-2">
          {/* 매출세부내역 */}
          <RevenueBreakdownChart ticker={ticker} selectedPeriod={selectedPeriod} />
        </Col>
        <Col xs={12} sm={12} md={12} lg={4} className="mb-2">
          {/* 이익률 */}
          <ProfitMarginLineChart ticker={ticker} selectedPeriod={selectedPeriod} />
        </Col>
        <Col xs={12} sm={12} md={12} lg={4} className="mb-2">
          {/* EPS */}
          <EPSLineChart ticker={ticker} selectedPeriod={selectedPeriod} />
        </Col>
      </Row>
      <Row style={{ margin: "0 auto" }}>
        <Col xs={12} sm={12} md={12} lg={4} xl={4} className="mb-2">
          {/*비용 비율 */}
          <ExpenseRatioChart ticker={ticker} selectedPeriod={selectedPeriod} />
        </Col>
        <Col xs={12} sm={12} md={12} lg={4} xl={4} className="mb-2">
          {/* R&D 비율 */}
          <RnDRatioChart ticker={ticker} selectedPeriod={selectedPeriod} />
        </Col>
        <Col xs={12} sm={12} md={12} lg={4} xl={4} className="mb-2">
          {/* ebit, ebita chart */}
          <EbitEbitdaLineChart ticker={ticker} selectedPeriod={selectedPeriod} />
        </Col>
      </Row>
    </div>
  );
}
